module.exports = __webpack_public_path__ + "static/media/call_white.fc80a682.svg";